<template>
  <div class="v-card" :class="{ 'v-card--is-ghostly': isGhostly }">
    <div class="v-card__vertical-position" :id="sectionId"></div>
    <div class="v-card__header"
         :class="{ 'v-card__header--is-toggler': toggle, 'v-card__header--is-toggler--is-open': isOpenControl }"
         v-if="$slots.header"
         @click.stop.prevent="toggle ? isOpenControl = !isOpenControl : false">

      <slot name="header"></slot>
    </div>

    <transition name="slide">
      <div class="v-card__body"
           :class="{ 'v-card__body--has-no-padding': !padding, 'v-card__body--scrollable': scrollable }"
           v-show="isOpenControl">

        <slot></slot>
      </div>
    </transition>

    <div class="v-card__footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  import { ErrorBag } from 'vee-validate';
  import jqueryTouchswipe from 'jquery-touchswipe';
  import sweetalert from "sweetalert";


  export default {
    data() {
      return {
        isOpenControl: this.isOpen
      }
    },
    props: {
      isOpenResponsive: {
        default() { return {} },
        type: Object,
      },
      isOpen: {
        default: true,
        type: Boolean,
      },
      toggle: {
        default: true,
        type: Boolean,
      },
      padding: {
        default: true,
        type: Boolean,
      },
      sectionId: {
        default: '',
        type: [String, Number]
      },
      isGhostly: {
        default: false,
        type: Boolean,
      },
      scrollable: {
        default: false,
        type: Boolean,
      },
      errorsToListen: {
        default: () => [],
        type: Array,
      }
    },
    computed: {
      isOpenResponsiveComputed() {
        if (Object.keys(this.isOpenResponsive).length !== 0 && this.isOpenResponsive.constructor === Object) {
          if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
          ) {
            return this.isOpenResponsive.mobile
          } else {
            return this.isOpenResponsive.desktop
          }
        } else {
          return this.isOpen;
        }
      }
    },
    methods: {
      checkForErrors: (errors, fields) => {
        let err = errors.filter(error => {
          return fields.indexOf(error.field) !== -1;
        });

        return !!err.length;
      }
    },
    created() {
      this.isOpenControl = this.isOpenResponsiveComputed;
      this.$root.$on('validation-error', (errors) => {
        if (errors.items && errors.items.length && this.errorsToListen.length) {
          this.isOpenControl = this.checkForErrors(errors.items, this.errorsToListen) || this.isOpenResponsiveComputed;
        }
      });
      // Navigating to this exact section (sticky-nav anchor click or a page-load hash -
      // see admin/app.js scrollToCard()/checkIfNeededScrollToCard()) must expand it first
      // if it's a collapsed accordion (e.g. Dump, collapsed by default), so the
      // destination is immediately useful rather than landing on a closed header.
      this.$root.$on('scroll-to-section', (sectionId) => {
        if (this.toggle && this.sectionId && String(this.sectionId) === String(sectionId)) {
          this.isOpenControl = true;
        }
      });
    }
  }

  $(function () {
    $('#swipeTableBar').swipe({
      swipeLeft: function () {
        if ($('.date-controls').length) {
          $('#dateFilterNextBtn').click();
        } else {
          sweetalert('Oops!', 'Please choose a date first', 'info');
        }
      },
      swipeRight: function () {
        if ($('.date-controls').length) {
          $('#dateFilterPrevBtn').click();
        } else {
          sweetalert('Oops!', 'Please choose a date first', 'info');
        }
      }
    });
  });
</script>